var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component__settings_header"},[_c('div',{staticClass:"box__icon--settings",on:{"click":_vm.handleClickSettings}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon--settings"},[_c('img',{attrs:{"src":"/images/_SVGs/chart.svg","onload":"SVGInject(this)","width":"100%"}})])
}]

export { render, staticRenderFns }